{
    "webshop_offer_voucher_correctCode": "Code correct saisi",
    "webShop_howToFindId_desc": "Vous pouvez retrouver et copier votre ID personnel à partir de votre profil.",
    "webShop_howToFindId_link": "Où trouver mon ID personnel ?",
    "webshop_offer_voucher_codeIsIncorrect": "Le code est incorrect",
    "webshop_offer_voucher_enterYourCode": "Saisissez votre ID personnel",
    "webShop_unexpectedError_desc": "Une erreur inattendue s'est produite. Veuillez réessayer ultérieurement.",
    "webShop_accountBanned_desc": "Compte banni !",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Conditions générales d'utilisation",
    "webshop_purchase_privacyPolicy": "Protection des données",
    "webshop_legal_1": "Mentions légales",
    "webshop_support_1": "Support",
    "mbs_access_welcome_desc": "Bienvenue, {0}",
    "btn_login": "Connexion",
    "mbs_access_error_sessionExpired_desc": "Votre session a expiré. Veuillez saisir manuellement l'ID de votre compte."
}
